import { render, staticRenderFns } from "./SectionTabs.vue?vue&type=template&id=7b3b5246&scoped=true&"
import script from "./SectionTabs.vue?vue&type=script&lang=js&"
export * from "./SectionTabs.vue?vue&type=script&lang=js&"
import style0 from "./SectionTabs.vue?vue&type=style&index=0&id=7b3b5246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3b5246",
  null
  
)

export default component.exports